// extracted by mini-css-extract-plugin
export default {"titleContainer":"aK0eQ","mainSubRatings":"nfagU","aside":"Mhw1K"};